import { render } from "./EditingMediaBroadcastAndAdvert.vue?vue&type=template&id=77263b9f"
import script from "./EditingMediaBroadcastAndAdvert.vue?vue&type=script&lang=js"
export * from "./EditingMediaBroadcastAndAdvert.vue?vue&type=script&lang=js"
script.render = render

export default script